import { Environment } from 'app/interfaces/configuration';

const baseUrl = 'virtual-agent-prod.truvideo.com';
const logo = 'assets/icons/cdk_icon.jpg';

const codes = [
  {
    type: 'Chatbot',
    url: `${baseUrl}/chat?origin=webbot-cdk`,
    logo: logo,
  },
  {
    type: 'Demos',
    url: `${baseUrl}/demos`,
    logo: logo,
  },
  {
    type: 'Voicebot',
    url: 'tel:+1 863 336 6381',
    logo: logo,
    description: 'New customer creation',
  },
  {
    type: 'Voicebot',
    url: 'tel:+1 863 624 5623 ',
    logo: logo,
    description: 'Existing customer validation',
  },
];

export const environment: Environment = {
  metabaseUrl:
    'https://analytics.truvideo.com/public/dashboard/3298378a-41da-4abf-a537-56b2215f3ac5?tab=39-overview&date_range=2024-01-01~2024-02-04#titled=false',
  engineUrl: 'https://ai-engine-api.truvideo.com/v1',
  chatEngineUrl: 'https://aiva-chatbot.truvideo.com/v1',
  platformUrl: 'https://command-center-api.truvideo.com/api/v1',
  authenticationApiUrl: 'https://authentication-api.truvideo.com/v1',
  profileNamesFromAuthApi: true,
  botOrigin: 'webbot-cdk',
  notificationApi: 'https://notification-api-beta.truvideo.com/api/v1',
  customLinksApi: 'https://custom-links-api.truvideo.com/api/v1',
  subAccountUuidCL: '8e80ee46-65ca-42ca-8377-27d6a58d825c',
  baseUrl: baseUrl,
  qrCodes: codes,
  intentId: '65b2a49796b34d8cbe1153cf',
  logopath: 'assets/images/logo/excellence-motors-logo.svg',
  idDashboard: 463,
  botIntentUID: '65e7699ee8c128958440872a',
  dataSource: 'https://virtual-agent-prod.cdk-aiva.com',
  chatBotWsUrl: 'https://aiva-chatbot.truvideo.com/chat-ws',
  interactionTrackingbaseUrl: 'https://interaction-tracking-ui.truvideo.com',
  interactionTrackingApiUrl: 'https://interaction-tracking-api.truvideo.com/api/v1',
  urlToDownloadExtension: 'https://truvideo-files-production.s3.us-west-2.amazonaws.com',
  kenilityEngineUrl: 'https://kenility-ai-engine-prod.truvideo.com/v1',
  defaultFollowUpId: '69727b7a800c4e36886e0bdb',
  // Cloudflare Turnstile public site key. One shared key is used across all
  // environments (local/beta/rc/prod); the prod host must be in this widget's
  // Hostname Management list in the Cloudflare dashboard before deploy.
  turnstileSiteKey: '0x4AAAAAADu9YWIkoky_jDuq',

  // NORA_FEATURES gate (baked in at build time from the env var by Dockerfile.local).
  noraFeatures: true,
  // Voice Pipeline Evaluation page (/voice-bakeoff): sidebar entry + route.
  voiceBakeoff: false,
  sentry: {
    enabled: true,
    dsn: 'https://75063e82e55889b0a7916debfa8e72f1@o4507029663121408.ingest.us.sentry.io/4507470888173568',
    release: 'VIRTUAL-AGENT-UI-PROD',
    environment: 'production',
    tracingOrigins: ['https://virtual-agent-prod.truvideo.com'],
  },
};

export const METABASE_SECRET_KEY = 'c2391bd5d2b2390dc9d99495377a8738c7e135ef820ff3ddd0c6771d076324c0';
